import { Popper } from "@thimble/core-lib";

export const PopupPreset: any = {
  className: 'smb-popper--tooltip smb-popper--zoom-y',
  modifiers: [Popper.modifiers.sameWidth, Popper.modifiers.createOffsetModifier(0, 10)],
};